var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "firma-dialog-container" },
    [
      _c(
        "div",
        { staticClass: "header-container" },
        [
          _c("CustomDialogHeaderComponent", {
            attrs: { headerTitle: _vm.texts.title },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.gridItems && _vm.gridItems.length && !_vm.loadingSpinner
            ? _c("Grid", {
                attrs: {
                  itemData: _vm.gridItems,
                  gridConfiguration: _vm.gridConfiguration,
                  toolbarOptions: [],
                  commandClick: _vm.onCommandClick,
                  rowDataBound: _vm.onRowDataBound,
                },
              })
            : _vm._e(),
          _vm.showInfoBar
            ? _c("InfoBarComponent", {
                staticClass: "info-bar",
                attrs: { infoText: _vm.texts.errorText, type: _vm.errorBar },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "custom-dialog-action-buttons-container" },
        [
          _vm.gridItems && _vm.gridItems.length && !_vm.loadingSpinner
            ? _c("LfLabelButtonComponent", {
                staticClass: "button",
                attrs: {
                  text: _vm.texts.accept,
                  action: () => _vm.closeCustomDialogAction(),
                  variant: "solid",
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.loadingSpinner || _vm.gridItems.length === 0
        ? _c("SpinnerLayerComponent", {
            staticClass: "spinner-layer",
            attrs: { loadingText: _vm.spinnerText.receiving },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }